import React from 'react'
import PropTypes from 'prop-types'

import { DropdownSlider } from 'Components/SearchFilterFactory/PanelForms'
import {
  _BedItem,
  _BedItemText,
  _BedTypeGrid,
  _DropdownSelect,
  _FilterContainer,
  _DropdownSelectContainer,
} from './styles'

const FilterBar = ({
  priceFilter,
  priceMetaData,
  priceChangeHandler,
  sqftFilter,
  sqftMetaData,
  sqftChangeHandler,
  bedFilter,
  bedTypeList = [],
  bedFilterChangeHandler,
  isMobileApp,
  isMobile,
  googleAnalyticsEvent,
  pageFrom,
}) => {
  const dropdownMenuTitle = bedFilter?.length === 0 ? 'All Beds' : `Beds: ${bedFilter.join(', ')}`

  return (
    <_FilterContainer>
      <DropdownSlider
        selectedVal={priceFilter}
        label="All Prices"
        onChange={priceChangeHandler}
        metaData={{ ...priceMetaData }}
        isMobileApp={isMobileApp}
        mobileFullPagePopup={isMobile || isMobileApp}
        gaFromPage={pageFrom}
        gaFromComponent={'PreconPriceFilter'}
      />
      <_DropdownSelectContainer>
        <_DropdownSelect
          title={dropdownMenuTitle}
          closeOnSelect={false}
          blurBackground={false}
          gaFromComponent={'PreconBedFilter'}
          gaFromPage={pageFrom}
          isMobileApp={isMobileApp}
          mobileFullPagePopup={isMobile || isMobileApp}
          googleAnalyticsEvent={googleAnalyticsEvent}
        >
          <_BedTypeGrid threeCol={bedTypeList && bedTypeList.length > 2}>
            {bedTypeList && bedTypeList.map(bed => (
              <_BedItem
                key={bed}
                onClick={() => bedFilterChangeHandler(bed)}
                active={bedFilter.includes(bed)}
              >
                <_BedItemText>{bed !== 'Studio' ? `${bed} BD` : 'Studio'}</_BedItemText>
              </_BedItem>
            ))}
          </_BedTypeGrid>
        </_DropdownSelect>
      </_DropdownSelectContainer>
      <DropdownSlider
        selectedVal={sqftFilter}
        customTitle={sqftFilter ? `${sqftFilter?.replace(',', ' - ')} ft\u00B2` : null}
        label="All Sqft"
        section="size_range"
        onChange={sqftChangeHandler}
        metaData={sqftMetaData}
        isMobileApp={isMobileApp}
        mobileFullPagePopup={isMobile || isMobileApp}
        gaFromPage={pageFrom}
        gaFromComponent={'PreconSqftFilter'}
      />
    </_FilterContainer>
  )
}

FilterBar.propTypes = {
  priceFilter: PropTypes.string,
  priceMetaData: PropTypes.shape({}),
  priceChangeHandler: PropTypes.func,
  sqftFilter: PropTypes.string,
  sqftMetaData: PropTypes.shape({}),
  sqftChangeHandler: PropTypes.func,
  bedFilter: PropTypes.arrayOf(PropTypes.string),
  bedTypeList: PropTypes.arrayOf(PropTypes.string),
  bedFilterChangeHandler: PropTypes.func,
  isMobileApp: PropTypes.bool,
  isMobile: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  pageFrom: PropTypes.string,
}

export default FilterBar
